
import { createRouter, RouteRecordRaw,createWebHashHistory } from 'vue-router'
import HomeView from '../HomeView.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        redirect:'/UploadView',
        children:[
            {path: '/UploadView',name: 'UploadView',component: () => import('../views/UploadView.vue')},
            {path: '/BankView',name: 'BankView',component: () => import('../views/BankView.vue')},
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
